import script from "./VInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__